import angular from 'angular';
import 'ui-select';
import 'ng-flow';
import 'angular-bootstrap';
import 'ng-file-upload';
import 'angulargrid/angulargrid.js';
import 'infinite-scroll';
import './librariesServices';
import 'ng-img-crop';
import '../../locale';
import '../../common/commonDirectives';


// Define the module directly like other modules in the application
const librariesControllers = angular.module('applicationModule.librariesControllers', [
    'angularGrid',
    'applicationModule.librariesServices',
    'flow',
    'infinite-scroll',
    'ngFileUpload',
    'ngImgCrop',
    'ui.bootstrap',
    'ui.select'
]);

librariesControllers.controller('LibrariesController', ['$scope', '$rootScope', '$stateParams', 'Libraries', 'growl', 'Permissions', '$window', function ($scope, $rootScope, $stateParams, Libraries, growl, Permissions, $window) {

    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('libraries');
    $scope.application_id = $stateParams.application_id;
    $scope.package_id = null;
    const token = localStorage.getItem('appsoup:userToken');
    let files = [];
    let page = 0;
    const amount = 16;
    let canLoad = true;
    $scope.filesChosen = [];
    $scope.files = [];
    $scope.isLoading = true;
    $scope.disableLoad = true;
    $scope.check = false;
    $scope.search = {};

    $scope.angularGridOptions = {
        gridWidth: 300,
        gutterSize: 10,
        refreshOnImgLoad: true
    };

    Libraries.get($scope.application_id).then(function (result) {
        let data = result.data;

        if (data.success) {
            $scope.isLoading = true;
            $scope.disableLoad = true;
            files = data.files;
            $scope.filesChosen = data.files;
            $scope.package_id = data.packageId;
        } else {
            growl.error('MODULES.LIBRARIES.ERROR.' + data.error);
        }
    }).finally(function () {
        $rootScope.doingResolve = false;
        $scope.isLoading = false;
        $scope.disableLoad = false;
        $scope.moreImage();
    });

    $scope.searchMedia = function (search) {
        if (!angular.isUndefinedNullOrEmpty(search.title)) {
            const title = search.title.toLowerCase();

            $scope.files = [];
            $scope.filesChosen = [];
            page = 0;

            angular.forEach(files, function (v) {
                const mediaName = v.name.toLowerCase().slice(0, -4);
                if (mediaName.indexOf(title) !== -1) {
                    $scope.filesChosen.push(v);
                }
            });

            $scope.moreImage();
        } else {
            if ($scope.check) {
                $scope.clearSearch();
                $scope.moreImage();
            }
        }
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        $scope.files = [];
        $scope.filesChosen = angular.copy(files);
        page = 0;
    };

    $scope.loadMore = function () {
        const isBottom = ($window.innerHeight + $window.pageYOffset + $window.innerHeight * 0.5) >= document.body.scrollHeight;

        if (isBottom && canLoad) {
            canLoad = false;
            $scope.moreImage();
        }
        if (!isBottom) {
            canLoad = true;
        }
    };

    $scope.moreImage = function () {
        $scope.isLoading = true;
        const newFilesList = $scope.filesChosen.slice(page * amount, (page + 1) * amount);

        $scope.files = $scope.files.concat(newFilesList);
        $scope.isLoading = false;
        page++;
    };

    $scope.flowInit = {
        target: '/api/app/library/upload/' + $scope.application_id,
        testChunks: false,
        chunkSize: 20480 * 1024,
        forceChunkSize: true,
        headers: {
            'Authorization': 'Bearer ' + token.toString()
        }
    };

    $scope.fileValidate = function (file) {
        if (file.size > 2097152) {
            growl.error('ERROR.SIZE_FILE_2MB');

            return false;
        }

        return true;
    };

    $scope.fileSuccess = function (file, messageStr) {
        const message = angular.fromJson(messageStr);

        if (message.success) {
            file.url = message.url;
            file.direct_url = message.direct_url;
            file.name = message.name;

            const f = [
                {
                    'url': message.url,
                    'direct_url': message.direct_url,
                    'name': message.name
                }
            ];

            const checkFile = function () {
                let fileState = false;
                angular.forEach(files, function (value) {
                    if (file.url === value.url) {
                        fileState = true;
                    }
                });

                return fileState;
            };

            if (checkFile()) {
                growl.error('ERROR.FILE_EXISTS');
            } else {
                files = f.concat(files);
                $scope.filesChosen = f.concat($scope.filesChosen);
                $scope.files = f.concat($scope.files);

                growl.success('MODULES.LIBRARIES.SUCCESS.ADDED');
            }
        } else {
            growl.error(message.error || 'MODULES.LIBRARIES.ERROR.undefined');
        }

        file.cancel();
    };

    $scope.deleteImage = function (file) {
        Libraries.remove($scope.application_id, file).then(function (result) {
            let data = result.data;
            if (data.success) {
                angular.forEach(files, function (value, key) {
                    const url = value.url;
                    if (url.indexOf(file.url) !== -1) {
                        files.splice(key, 1);
                    }
                });
                angular.forEach($scope.files, function (value, key) {
                    const url = value.url;
                    if (url.indexOf(file.url) !== -1) {
                        $scope.files.splice(key, 1);
                    }
                });
                angular.forEach($scope.filesChosen, function (value, key) {
                    const url = value.url;
                    if (url.indexOf(file.url) !== -1) {
                        $scope.filesChosen.splice(key, 1);
                    }
                });
                growl.success('MODULES.LIBRARIES.SUCCESS.DELETE');
            } else {
                growl.error('MODULES.LIBRARIES.ERROR.' + data.error);
            }
        });
    };

    $scope.$watch('search', function () {
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
        });
    }, true);
}]);

librariesControllers.controller('LibrariesModalController', ['$scope', '$rootScope', '$stateParams', 'Libraries', 'growl', 'Permissions', '$modalInstance', '$modal', function ($scope, $rootScope, $stateParams, Libraries, growl, Permissions, $modalInstance, $modal) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('libraries');
    $scope.application_id = $stateParams.application_id;
    $scope.package_id = null;
    const token = localStorage.getItem('appsoup:userToken');
    let files = [];
    let page = 0;
    const amount = 16;
    $scope.filesChosen = [];
    $scope.files = [];
    $scope.isLoading = true;
    $scope.disableLoad = true;
    $scope.check = false;
    $scope.search = {};
    $scope.selectedFile = undefined;

    $scope.angularGridOptions = {
        gridWidth: 300,
        gutterSize: 10,
        refreshOnImgLoad: true
    };

    Libraries.get($scope.application_id).then(function (result) {
        let data = result.data;
        if (data.success) {
            $scope.isLoading = true;
            $scope.disableLoad = true;
            files = data.files;
            $scope.filesChosen = data.files;
            $scope.package_id = data.packageId;
        } else {
            growl.error('MODULES.LIBRARIES.ERROR.' + data.error);
        }
    }).finally(function () {
        $rootScope.doingResolve = false;
        $scope.isLoading = false;
        $scope.disableLoad = false;
        $scope.moreImage();
    });

    $scope.searchMedia = function (search) {
        if (!angular.isUndefinedNullOrEmpty(search.title)) {
            const title = search.title.toLowerCase();

            $scope.files = [];
            $scope.filesChosen = [];
            page = 0;

            angular.forEach(files, function (v) {
                const mediaName = v.name.toLowerCase().slice(0, -4);
                if (mediaName.indexOf(title) !== -1) {
                    $scope.filesChosen.push(v);
                }
            });

            $scope.moreImage();
        } else {
            if ($scope.check) {
                $scope.clearSearch();
                $scope.moreImage();
            }
        }
    };

    $scope.clearSearch = function () {
        $scope.search = {};
        $scope.files = [];
        $scope.filesChosen = angular.copy(files);
        page = 0;
    };

    $scope.moreImage = function () {
        $scope.isLoading = true;

        const newFilesList = $scope.filesChosen.slice(page * amount, (page + 1) * amount);

        $scope.files = $scope.files.concat(newFilesList);
        $scope.isLoading = false;
        page++;
    };

    $scope.flowInit = {
        target: '/api/app/library/upload/' + $scope.application_id,
        testChunks: false,
        chunkSize: 20480 * 1024,
        forceChunkSize: true,
        headers: {
            'Authorization': 'Bearer ' + token.toString()
        }
    };

    $scope.fileValidate = function (file) {
        if (file.size > 2097152) {
            growl.error('ERROR.SIZE_FILE_2MB');

            return false;
        }

        return true;
    };

    $scope.fileSuccess = function (file, messageStr) {
        const message = angular.fromJson(messageStr);
        if (message.success) {
            file.url = message.url;
            file.direct_url = message.direct_url;
            file.name = message.name;

            const f = [
                {
                    'url': message.url,
                    'direct_url': message.direct_url,
                    'name': message.name
                }
            ];

            const checkFile = function () {
                let fileState = false;
                angular.forEach(files, function (value) {
                    if (file.url === value.url) {
                        fileState = true;
                    }
                });

                return fileState;
            };

            if (checkFile()) {
                growl.error('ERROR.FILE_EXISTS');
            } else {
                files = f.concat(files);
                $scope.filesChosen = f.concat($scope.filesChosen);
                const tmpFiles = f.concat($scope.files);
                $scope.files = angular.copy(tmpFiles);

                growl.success('MODULES.LIBRARIES.SUCCESS.ADDED');
            }
        } else {
            growl.error(message.error || 'MODULES.LIBRARIES.ERROR.undefined');
        }

        file.cancel();
    };

    $scope.deleteImage = function (file) {
        Libraries.remove($scope.application_id, file).then(function (result) {
            let data = result.data;
            if (data.success) {
                const tmpFiles = angular.copy($scope.files);

                if (angular.isDefined($scope.selectedFile) && $scope.selectedFile.url === file.url) {
                    $scope.selectedFile = undefined;
                }
                angular.forEach(files, function (value, key) {
                    const url = value.url;
                    if (url.indexOf(file.url) !== -1) {
                        files.splice(key, 1);
                    }
                });
                angular.forEach(tmpFiles, function (value, key) {
                    const url = value.url;
                    if (url.indexOf(file.url) !== -1) {
                        tmpFiles.splice(key, 1);
                    }
                });
                angular.forEach($scope.filesChosen, function (value, key) {
                    const url = value.url;
                    if (url.indexOf(file.url) !== -1) {
                        $scope.filesChosen.splice(key, 1);
                    }
                });
                $scope.files = angular.copy(tmpFiles);
                growl.success('MODULES.LIBRARIES.SUCCESS.DELETE');
            } else {
                growl.error('MODULES.LIBRARIES.ERROR.' + data.error);
            }
        });
    };

    $scope.selectImage = function (file) {
        if ($scope.writeAccess) {
            $scope.selectedFile = {
                'url': file.url,
                'direct_url': file.direct_url,
                'name': file.name
            };
        }
    };

    $scope.deselectImage = function () {
        $scope.selectedFile = undefined;
    };

    $scope.insertImage = function () {
        $modalInstance.close($scope.selectedFile);
    };

    $scope.$watch('search', function () {
        $scope.check = false;
        angular.forEach($scope.search, function (val) {
            if (angular.isDefined(val) && angular.isDefinedNotEmpty(val)) {
                $scope.check = true;
            }
        });
    }, true);

    $scope.openCropModal = function () {
        const modalCropInstance = $modal.open({
            templateUrl: 'views/common/components/modals/cropModal.tpl.html',
            controller: 'LibrariesCropModalController',
            size: 'xlg',
            animation: true
        });

        modalCropInstance.result.then(function (file) {
            if (file) {
                files = file.concat(files);
                $scope.filesChosen = file.concat($scope.filesChosen);
                const tmpFiles = file.concat($scope.files);
                $scope.files = angular.copy(tmpFiles);
            }
        });
    };

    $scope.removeCropImage = function () {
        $scope.data = null;
    };
}]);

librariesControllers.controller('LibrariesCropController', ['$scope', '$rootScope', '$stateParams', 'Libraries', 'growl', 'Permissions', function ($scope, $rootScope, $stateParams, Libraries, growl, Permissions) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('libraries');
    $scope.application_id = $stateParams.application_id;

    $scope.isLoading = false;
    $scope.files = [];
    $scope.imageStrings = [];
    $scope.croppedStrings = [];

    $scope.dataURLToFile = function (dataurl, filename) {
        let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, {type: mime});
    };

    $scope.upload = function (file, index) {
        file.cancel();

        $scope.isLoading = true;
        Libraries.upload($scope.application_id, $scope.dataURLToFile($scope.croppedStrings[index], $scope.files[index].name)).then(function (result) {
            let data = result.data;
            if (data.success) {
                growl.success('MODULES.LIBRARIES.SUCCESS.ADDED');
            } else {
                growl.error('MODULES.LIBRARIES.ERROR.' + data.error);
            }
        }).finally(function () {
            $scope.isLoading = false;
        });

        $scope.files.splice(index, 1);
        $scope.imageStrings.splice(index, 1);
        $scope.croppedStrings.splice(index, 1);
    };

    $scope.remove = function (file) {
        if (file) {
            file.cancel();
        }
    };

    $scope.fileValidate = function (file) {
        if (file) {
            if (file.size > 2097152) {
                growl.error('ERROR.SIZE_FILE_2MB');

                return false;
            }

            return true;
        }
    };

    $scope.processFiles = function (files) {
        angular.forEach(files, function (flowFile) {
            if (!$scope.fileValidate(flowFile.file)) {
                flowFile.cancel();

                return false;
            }

            $scope.files.push(flowFile.file);

            const fileReader = new FileReader();
            fileReader.onload = function (event) {
                const uri = event.target.result;
                $scope.imageStrings.push(uri);
                $scope.croppedStrings.push(uri);
            };
            fileReader.readAsDataURL(flowFile.file);
        });
    };
}]);

librariesControllers.controller('LibrariesCropModalController', ['$scope', '$rootScope', '$stateParams', 'Libraries', 'growl', 'Permissions', '$modalInstance', function ($scope, $rootScope, $stateParams, Libraries, growl, Permissions, $modalInstance) {
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('libraries');
    $scope.application_id = $stateParams.application_id;

    $scope.isLoading = false;
    $scope.files = [];
    $scope.imageStrings = [];
    $scope.croppedStrings = [];

    $scope.dataURLToFile = function (dataurl, filename) {
        let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, {type: mime});
    };

    $scope.upload = function (file, index) {
        file.cancel();

        $scope.isLoading = true;
        Libraries.upload($scope.application_id, $scope.dataURLToFile($scope.croppedStrings[index], $scope.files[index].name)).then(function (result) {
            let data = result.data;
            if (data.success) {
                growl.success('MODULES.LIBRARIES.SUCCESS.ADDED');

                const f = [
                    {
                        'url': data.url,
                        'direct_url': data.direct_url,
                        'name': data.name
                    }
                ];

                $modalInstance.close(f);

            } else {
                growl.error('MODULES.LIBRARIES.ERROR.' + data.error);
            }
        }).finally(function () {
            $scope.isLoading = false;
        });

        $scope.files.splice(index, 1);
        $scope.imageStrings.splice(index, 1);
        $scope.croppedStrings.splice(index, 1);
    };

    $scope.remove = function (file) {
        if (file) {
            file.cancel();
        }
    };

    $scope.fileValidate = function (file) {
        if (file) {
            if (file.size > 2097152) {
                growl.error('ERROR.SIZE_FILE_2MB');

                return false;
            }

            return true;
        }
    };

    $scope.processFiles = function (files) {
        angular.forEach(files, function (flowFile) {
            if (!$scope.fileValidate(flowFile.file)) {
                flowFile.cancel();

                return false;
            }

            $scope.files.push(flowFile.file);

            const fileReader = new FileReader();
            fileReader.onload = function (event) {
                const uri = event.target.result;
                $scope.imageStrings.push(uri);
                $scope.croppedStrings.push(uri);
            };
            fileReader.readAsDataURL(flowFile.file);
        });
    };

    $scope.closeCurrentModal = function () {
        $modalInstance.close();
    };
}]);

export default librariesControllers;
